import { Outlet, Link, useNavigate } from "react-router-dom";
import { Sidebar, type SidebarNavItem } from "@/components/layout/Sidebar";
import { useAuth } from "@/lib/auth-context";

const navItems: SidebarNavItem[] = [
  { label: "Dashboard", to: "/dashboard" },
  { label: "Leads", to: "/dashboard/leads" },
  { label: "Conversations", to: "/dashboard/conversations" },
  { label: "Calls", to: "/dashboard/calls" },
  { label: "Analytics", to: "/dashboard/analytics" },
  { label: "Automation", to: "/dashboard/automation" },
  { label: "Billing", to: "/dashboard/billing" },
  { label: "Settings", to: "/dashboard/settings" },
];

export function DashboardLayout() {
  const { user, organizations, logout } = useAuth();
  const navigate = useNavigate();

  async function handleLogout() {
    await logout();
    navigate("/login", { replace: true });
  }

  return (
    <div className="flex min-h-screen bg-paper">
      <Sidebar
        title="Callback"
        subtitle={organizations[0]?.organizationName ?? user?.fullName ?? ""}
        items={navItems}
        footer={
          <div className="flex flex-col gap-2">
            <span className="truncate text-xs text-ink-soft" title={user?.email}>
              {user?.email}
            </span>
            <button
              type="button"
              onClick={handleLogout}
              className="text-left text-xs font-medium text-ink-soft hover:text-ink"
            >
              Log out
            </button>
            <Link to="/" className="text-xs text-ink-soft hover:text-ink">
              ← Back to site
            </Link>
          </div>
        }
      />
      <div className="flex-1 overflow-y-auto">
        <div className="mx-auto max-w-5xl px-8 py-8">
          <Outlet />
        </div>
      </div>
    </div>
  );
}
